// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fGNY","fullView":"styles_fullView__1Q-Yo"};